import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling ~600px (past the first CTA in hero)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-118">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-5 right-5 z-50" data-id="element-119">
          <a href="https://pay.hotmart.com/R104866725J" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gold-main text-white font-lora font-semibold text-sm py-3 px-5 rounded-full shadow-lg hover:shadow-xl hover:bg-gold-dark transition-all" data-id="element-120">
            Quiero mi eBook
          </a>
        </motion.div>}
    </AnimatePresence>;
}